import { Link, useLocation } from "react-router-dom";

export const PublicHeader = () => {
  const { pathname } = useLocation();
  const link = (to, label, testid) => (
    <Link
      to={to}
      data-testid={testid}
      className={`text-base transition-colors hover:text-[var(--text)] ${
        pathname === to ? "text-[var(--alba-text)]" : "text-[var(--muted)]"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-40 border-b border-[var(--line-soft)] bg-[color-mix(in_srgb,var(--bg)_82%,transparent)] backdrop-blur-md">
      <div className="wrap flex h-[72px] items-center justify-between">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-2.5 font-display text-[23px] text-[var(--text)]">
          <span className="paso-dot" />Da el <em className="not-italic text-[var(--alba-text)] italic">Paso</em>
        </Link>
        <nav className="flex items-center gap-5 sm:gap-7">
          {link("/", "Inicio", "nav-inicio")}
          <Link
            to="/claridad"
            data-testid="nav-empieza-aqui"
            className="btn btn-p !px-5 !py-2.5 !text-[14px]"
          >
            Empieza aquí
          </Link>
        </nav>
      </div>
    </header>
  );
};
